/**
 * Project - sonynetwork.fa2chat-nuro-docsbot
 *
 * @desc 画像メッセージ
 *
 * @author dvinhthai
 * @copyright Copyright 2023 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-card class="fc-image-message" :class="[messageClass]">
  <el-dropdown @command="doMenu" @visible-change="dropdownVisibleChangeHandler" trigger="click">
    <img ref="image" class="image img_image-message" :src="imageSrc" :title="imageTitle" @click="imageClickHandler" @load="imageLoadHandler" />
    <el-dropdown-menu class="image-menu" slot="dropdown" :style="imageMenuStyle">
      <el-dropdown-item class="image-menu-item" command="openPreview">{{$t('画像を表示')}}</el-dropdown-item>
      <el-dropdown-item class="image-menu-item" command="download">{{$t('ダウンロード')}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</el-card>
</template>
<script>
import FcMessageUtil from '@/utils/FcMessageUtil'
import WindowUtil from '@/utils/WindowUtil'
import ServiceUtil from '@/utils/ServiceUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'

import {
  Card,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui'

export default {
  name: 'FcImageMessage',
  components: {
    'el-card': Card,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo'
  ],
  data() {
    return {
      lastImageClickX: 0,
      lastImageClickY: 0,
      imageMenuStyle: {
        top: 0,
        left: 0
      },
      imageSrc: '',
      imageLoadBeforeHeight: 0,
      imageLoadAfterHeight: 0
    }
  },
  mounted() {
    ServiceUtil.request('findAttachContent?contentId=' + (this.messageInfo.previewAttachContentId || this.messageInfo.attachContentId), null, {
      success: res => {
        this.imageLoadBeforeHeight = this.$el.offsetHeight
        this.imageSrc = window.URL.createObjectURL(res)
      }
    }, 'blob', 'GET')
  },
  computed: {
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageClass() {
      return 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * 画像のタイトル
     * @return {String}
     */
    imageTitle() {
      return this.messageInfo.attachFileName
    }
  },
  methods: {
    /**
     * メニュー処理
     * @param  {string} command
     */
    doMenu(command) {
      if (command === 'openPreview') {
        this.openPreview()
      } else if (command === 'download') {
        this.download()
      }
    },
    /**
     * 画像クリックイベント処理
     * @param  {Event} event
     */
    imageClickHandler(event) {
      this.lastImageClickX = event.pageX
      this.lastImageClickY = event.pageY
    },
    /**
     * ドロップダウン開閉イベント処理
     * @param  {boolean} open
     */
    dropdownVisibleChangeHandler(open) {
      if (open) {
        setTimeout(_ => {
          this.imageMenuStyle.top = this.lastImageClickY + 'px !important'
          this.imageMenuStyle.left = this.lastImageClickX + 'px !important'
        }, 0)
      }
    },
    /**
     * 画像ロード処理
     * @param  {Event} event
     */
    imageLoadHandler(event) {
      this.imageLoadAfterHeight = this.$el.offsetHeight
      this.$emit('imageMessageLoad', this)
    },
    /**
     * 画像プレビューを開きます
     */
    openPreview() {
      WindowUtil.openPreviewImageWindow('findAttachContent?contentId=' + this.messageInfo.attachContentId, this.messageInfo.attachFileName)
    },
    /**
     * ファイルをダウンロードします。
     */
    download() {
      ServiceUtil.download('findAttachContent?contentId=' + this.messageInfo.attachContentId, this.messageInfo.attachFileName, this.emitUpdateDownloadStatus)
    },
    /**
     * Emit update download status
     */
    emitUpdateDownloadStatus() {
      if (this.messageInfo.distributionType !== MessageInfoConst.DISTRIBUTION_TYPE_FH_TO_FC) {
        return
      }
      this.$emit('updateDownloadStatus', this.messageInfo.attachContentId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcImageMessage.vue